import { render, staticRenderFns } from "./meal_select.vue?vue&type=template&id=2a8eea0a&scoped=true&lang=html&"
import script from "./meal_select.vue?vue&type=script&lang=js&"
export * from "./meal_select.vue?vue&type=script&lang=js&"
import style0 from "./meal_select.vue?vue&type=style&index=0&id=2a8eea0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8eea0a",
  null
  
)

export default component.exports